module.exports = __webpack_public_path__ + "static/media/AHW_01.d4c08ebb.jpg";